import { useState, useEffect } from "react";
import { UseAxios } from "../../../common/useAxios";
import defaultAxios from 'axios';
import { useNavigate } from "react-router-dom";
import { backendUrl } from "../../../common/constantVarialble";

interface SqlResponse {
    input_date: string;
    input_psn: string;
    last_update_dte: string | null;
    last_update_psn: string | null;
    prg_description: string;
    program_id: string;
    sql: string;
}

function ProgramDescriptionTab({ program_id, programDescription, setProgramDescription }: { program_id: string, programDescription: SqlResponse | null, setProgramDescription: React.Dispatch<React.SetStateAction<any>> }) {

    /*
    const [programDescription, setProgramDescription] =
        useState<ProgramType | null>(null);

    const { loading, data, error, refetch } = UseAxios({
        method: "post",
        url: "http://localhost:5000/api/request/",
        data: {
            program_id: "PERCENT-ADMIN-PRG-L-LSTSQLBYPROGRAMID",
            params: {
                program_id: program_id,
            },
            page_index: -1,
        },
    });

    useEffect(() => {
        console.log("programDetail");
        console.log(data);

        const programDtl = data?.data?.data[0];

        if (programDtl) {
            console.log("SSSSSSSS2222");
            console.log(programDtl.program_id);
            setProgramDescription(programDtl);
            console.log("SSSSSSSS");
            console.log(programDescription);
        }
    }, [data]);
    */
    const navigate = useNavigate();

    const updateDescription = async () => {
        try {
            if (!programDescription?.program_id.trim()) {
                alert("Enter PROGRAM_ID");
            }
            if (!programDescription?.prg_description.trim()) {
                alert("Enter program description");
            }

            const { data } = await defaultAxios({
                method: 'post',
                //url: 'http://localhost:5000/api/request/',
                url: backendUrl,
                data: {
                    program_id: 'PERCENT-ADMIN-PRG-C-UPDPROGRAMIDANDDESCRIPTION',
                    params: {
                        'p_program_id': program_id.trim(),
                        'p_new_program_id': programDescription?.program_id.trim(),
                        'p_description': programDescription?.prg_description.trim(),
                    },
                    page_index: -1,
                },
            });

            return data;

        } catch (error) {
            console.error(error);
            return null;
        }
    }

    const onUpdateDescriptionClick = async () => {
        const result = await updateDescription();
        if (result && result?.ok === true) {
            alert("Program description 저장 완료");
            // programDetail 페이지로 이동하면서 현재 페이지를 히스토리에서 삭제 - React-router-dom V6
            navigate(`/admin/sql/program?program_id=${programDescription?.program_id.trim()}`, { replace: true });
        }
    }

    return (
        <div className=" h-full flex flex-col w-full bg-gray-900 text-body justify-center items-center px-10 py-4">
            <form className="w-full">
                <div className="flex flex-wrap -mx-3 mb-6">
                    <div className="w-full px-3">
                        <label className="block uppercase tracking-wide text-xs text-white  font-bold mb-2">
                            PROGRAM ID
                        </label>
                        <input className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white focus:border-gray-500" id="nick" type="text" value={programDescription?.program_id}
                            onChange={(e) => {
                                setProgramDescription({ ...programDescription, program_id: e.target.value });
                            }}
                        />
                        <p className="text-gray-600 text-xs italic">Remove if not needed</p>
                    </div>
                </div>
                <div className="flex flex-wrap -mx-3 mb-6">
                    <div className="w-full px-3">
                        <label className="lock uppercase tracking-wide text-xs text-white  font-bold pb-2">
                            Description
                        </label>
                        <textarea className=" no-resize appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white focus:border-gray-500 h-48 resize-none" id="message" value={programDescription?.prg_description}
                            onChange={(e) => {
                                setProgramDescription({ ...programDescription, prg_description: e.target.value });
                            }}
                        ></textarea>
                        <p className="text-gray-600 text-xs italic">Re-size can be disabled by set by resize-none / resize-y / resize-x / resize</p>
                    </div>
                </div>
                {
                    programDescription &&
                    <div className="flex flex-wrap -mx-3 mb-6">
                        <div className="w-full px-3">
                            <label className="block uppercase tracking-wide text-white text-xs font-bold mb-2">
                                First commit user
                            </label>
                            <p className="text-body  border-b border-b-gray-100 pb-2">{programDescription.input_psn}</p>
                        </div>
                    </div>
                }
                <div className="flex flex-wrap -mx-3 mb-6">
                    <div className="w-full px-3">
                        <label className="block uppercase tracking-wide text-white text-xs font-bold mb-2">
                            First commit date
                        </label>
                        <p className="text-body  border-b border-b-gray-100 pb-2">{programDescription?.input_date}</p>
                    </div>
                </div>
                <div className="flex flex-wrap -mx-3 mb-6">
                    <div className="w-full px-3">
                        <label className="block uppercase tracking-wide text-white text-xs font-bold mb-2">
                            Last commit user
                        </label>
                        <p className="text-body  border-b border-b-gray-100 pb-2">{programDescription?.last_update_psn}</p>
                    </div>
                </div>
                <div className="flex flex-wrap -mx-3 mb-6">
                    <div className="w-full px-3">
                        <label className="block uppercase tracking-wide text-white text-xs font-bold mb-2">
                            Last commit date
                        </label>
                        <p className="text-body  border-b border-b-gray-100 pb-2">{programDescription?.last_update_dte}</p>
                    </div>
                </div>

            </form>

            <div className="m-2 w-full">
                <button className="group relative h-10 w-full px-4 overflow-hidden rounded-2xl bg-blue-500 text-lg font-bold text-white" onClick={onUpdateDescriptionClick}>
                    Update description
                    <div className="absolute inset-0 h-full w-full scale-0 rounded-2xl transition-all duration-300 group-hover:scale-100 group-hover:bg-white/30"></div>
                </button>
            </div>

        </div>
    );
}

export { ProgramDescriptionTab };